import React from 'react';
import clsx from 'clsx';
import styles from './index.scss';

export default function Input(props) {
  const { className, style, date, disabled, order = 'mdy', onClick, helperText, label } = props;

  const dayOrder = order.indexOf('d');
  const monthOrder = order.indexOf('m');
  const yearOrder = order.indexOf('y');
  let day = '';
  let month = '';
  let year = '';

  if (date) {
    day = date.date();
    month = date.month() + 1;
    year = date.year();
  }
  // Render button
  return (
    <div
      style={style}
      className={clsx(className, 'date-input-container', styles.container, disabled && 'disabled')}
      onClick={() => onClick?.()}
    >
      {!helperText && label && (
        <div className={clsx('label', 'date-input-label', styles.label)}>{label}</div>
      )}
      {helperText && (
        <div className={clsx('date-input-helper-text', styles.helperText)}>{helperText}</div>
      )}
      <div className={clsx('date-input-inner-container', styles.innerContainer)}>
        <div
          style={{ order: dayOrder }}
          className={clsx(
            'date-input-field',
            styles.input,
            !day && styles.placeholder,
            !day && 'date-input-field-placeholder'
          )}
        >
          {day || 'DD'}
        </div>
        <div
          style={{ order: monthOrder }}
          className={clsx(
            'date-input-field',
            styles.input,
            !month && styles.placeholder,
            !month && 'date-input-field-placeholder'
          )}
        >
          {month || 'MM'}
        </div>
        <div
          style={{ order: yearOrder }}
          className={clsx(
            'date-input-field',
            styles.input,
            !year && styles.placeholder,
            !year && 'date-input-field-placeholder'
          )}
        >
          {year || 'YYYY'}
        </div>
      </div>
    </div>
  );
}
